__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['amex-connect-root'].baseUrl;
import ModuleContainer from './components/AmexConnectRoot';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "^5.0.0"
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    '@americanexpress/amex-connect-core': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.8.3-18',
      module: require('@americanexpress/amex-connect-core')
    },
    '@americanexpress/data-manager-utils': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.4.5',
      module: require('@americanexpress/data-manager-utils')
    },
    '@americanexpress/react-ddl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.3.7',
      module: require('@americanexpress/react-ddl')
    },
    'react-transition-group': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '4.4.5',
      module: require('react-transition-group')
    },
    'gsap': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.13.0',
      module: require('gsap')
    },
    'react-intl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '6.8.9',
      module: require('react-intl')
    },
    '@americanexpress/one-app-module-wrapper': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.6.2',
      module: require('@americanexpress/one-app-module-wrapper')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'amex-connect-root') {
  global.getTenantRootModule = () => ModuleContainer;
  global.rootModuleName = 'amex-connect-root';
}